import React, { Suspense, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';

import * as ROUTES from '../../constants/routes';
import { withFreightForwarder } from '../../components/Session';
import Footer from '../../components/Footer';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const FreightForwarderUsersIndexPage = lazy(() => import('../FF_Users'));
const UserEditPage = lazy(() => import('../Users/edit'));
const UserNewPage = lazy(() => import('../Users/new'));

const CurrencyIndexPage = lazy(() => import('../Currencies'));
const CurrencyEditPage = lazy(() => import('../Currencies/edit'));
const CurrencyNewPage = lazy(() => import('../Currencies/new'));

const AgentIndexPage = lazy(() => import('../Agents'));
const AgentEditPage = lazy(() => import('../Agents/edit'));
const AgentNewPage = lazy(() => import('../Agents/new'));

const ClientIndexPage = lazy(() => import('../Client'));
const ClientEditPage = lazy(() => import('../Client/edit'));
const ClientNewPage = lazy(() => import('../Client/new'));

const ServiceProviderIndexPage = lazy(() => import('../ServiceProviders'));
const ServiceProviderEditPage = lazy(() => import('../ServiceProviders/edit'));
const ServiceProviderNewPage = lazy(() => import('../ServiceProviders/new'));

const ChargeIndexPage = lazy(() => import('../Charges'));
const ChargeEditPage = lazy(() => import('../Charges/edit'));
const ChargeNewPage = lazy(() => import('../Charges/new'));

const PortPairIndexPage = lazy(() => import('../PortPairs'));
const PortPairEditPage = lazy(() => import('../PortPairs/Edit'));
const PortPairNewPage = lazy(() => import('../PortPairs/new'));

const QuotePage = lazy(() => import('../Quote'));
const ShowQuotePage = lazy(() => import('../Quote/show'));
const QuoteNewPage = lazy(() => import('../Quote/new'));
const QuoteNewNoServicePage = lazy(() => import('../Quote/new_no_service'));

const BulkUpdatesPage = lazy(() => import('../BulkUpdates'));

const RateSheetsPage = lazy(() => import('../RateSheets'));
const RateSheetShowPage = lazy(() => import('../RateSheets/show'));

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    // marginLeft: "-24px",
    // marginRight: "-24px",
  },
  flexOne: {
    flex: 1,
  },
});

class FreightForwarderRouter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      clients: [],
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Grid container spacing={3} className={classes.flexOne}>
          <Grid item xs={12}>
            <Suspense fallback={<div></div>}>
              <Switch>
                {/* defualt to the quotes index */}
                {/* <Route exact path='/' render={(props) => <QuotePage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />} /> */}

                {/* *************************USERS ****************************** */}
                <Route
                  exact
                  path={ROUTES.FF_USERS}
                  render={(props) => (
                    <FreightForwarderUsersIndexPage
                      {...props}
                      freight_forwarder_id={props.match.params.freight_forwarder_id}
                    />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.FF_USERS_NEW}
                  render={(props) => (
                    <UserNewPage
                      {...props}
                      freight_forwarder_id={props.match.params.freight_forwarder_id}
                      lock_freight_forwarder={true}
                    />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.FF_USER}
                  render={(props) => {
                    return (
                      <UserEditPage {...props} user_id={props.match.params.user_id} lock_freight_forwarder={true} />
                    );
                  }}
                />

                {/* *************************CURRENCIES ****************************** */}

                <Route
                  exact
                  path={ROUTES.CURRENCIES}
                  render={(props) => (
                    <CurrencyIndexPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.CURRENCIES_NEW}
                  render={(props) => (
                    <CurrencyNewPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.CURRENCY}
                  render={(props) => {
                    return (
                      <CurrencyEditPage
                        {...props}
                        freight_forwarder_id={props.match.params.freight_forwarder_id}
                        currency_id={props.match.params.currency_id}
                      />
                    );
                  }}
                />

                {/* *************************AGENTS ****************************** */}

                <Route
                  exact
                  path={ROUTES.AGENTS}
                  render={(props) => (
                    <AgentIndexPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.AGENTS_NEW}
                  render={(props) => (
                    <AgentNewPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.AGENT}
                  render={(props) => {
                    return (
                      <AgentEditPage
                        {...props}
                        freight_forwarder_id={props.match.params.freight_forwarder_id}
                        agent_id={props.match.params.agent_id}
                      />
                    );
                  }}
                />

                {/* *************************CLIENTS ****************************** */}

                <Route
                  exact
                  path={ROUTES.CLIENTS}
                  render={(props) => (
                    <ClientIndexPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.CLIENTS_NEW}
                  render={(props) => (
                    <ClientNewPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.CLIENT}
                  render={(props) => {
                    return (
                      <ClientEditPage
                        {...props}
                        freight_forwarder_id={props.match.params.freight_forwarder_id}
                        client_id={props.match.params.client_id}
                      />
                    );
                  }}
                />

                {/* *************************SERVICE_PROVIDERS ****************************** */}

                <Route
                  exact
                  path={ROUTES.SERVICE_PROVIDERS}
                  render={(props) => (
                    <ServiceProviderIndexPage
                      {...props}
                      freight_forwarder_id={props.match.params.freight_forwarder_id}
                    />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.SERVICE_PROVIDERS_NEW}
                  render={(props) => (
                    <ServiceProviderNewPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.SERVICE_PROVIDER}
                  render={(props) => {
                    return (
                      <ServiceProviderEditPage
                        {...props}
                        freight_forwarder_id={props.match.params.freight_forwarder_id}
                        service_provider_id={props.match.params.service_provider_id}
                      />
                    );
                  }}
                />

                {/* *************************FCL CHARGES ****************************** */}

                <Route
                  exact
                  path={ROUTES.CHARGES}
                  render={(props) => {
                    let { chargeCodes, loadChargeCodes } = this.props;
                    return (
                      <ChargeIndexPage
                        {...props}
                        freight_forwarder_id={props.match.params.freight_forwarder_id}
                        chargeCodes={chargeCodes}
                        loadChargeCodes={loadChargeCodes}
                      />
                    );
                  }}
                />
                <Route
                  exact
                  path={ROUTES.CHARGES_NEW}
                  render={(props) => (
                    <ChargeNewPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.CHARGE}
                  render={(props) => {
                    return (
                      <ChargeEditPage
                        {...props}
                        freight_forwarder_id={props.match.params.freight_forwarder_id}
                        charge_id={props.match.params.charge_id}
                      />
                    );
                  }}
                />

                {/* *************************FCL SERVICES/Port Pair ****************************** */}

                <Route
                  exact
                  path={ROUTES.PORT_PAIRS_INDEX}
                  render={(props) => (
                    <PortPairIndexPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.PORT_PAIR_NEW}
                  render={(props) => (
                    <PortPairNewPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.PORT_PAIR}
                  render={(props) => {
                    return (
                      <PortPairEditPage
                        {...props}
                        freight_forwarder_id={props.match.params.freight_forwarder_id}
                        service_id={props.match.params.service_id}
                      />
                    );
                  }}
                />

                {/* *************************FCL QUOTES ****************************** */}

                <Route
                  exact
                  path={ROUTES.QUOTES_NEW}
                  render={(props) => (
                    <QuoteNewPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.QUOTES_NEW_NO_SERVICE}
                  render={(props) => (
                    <QuoteNewNoServicePage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />

                <Route
                  exact
                  path={ROUTES.QUOTES}
                  render={(props) => (
                    <QuotePage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.QUOTE}
                  render={(props) => {
                    let { currentFreightForwarder, chargeCodes, loadChargeCodes } = this.props;
                    return (
                      <ShowQuotePage
                        {...props}
                        chargeCodes={chargeCodes}
                        loadChargeCodes={loadChargeCodes}
                        currentFreightForwarder={currentFreightForwarder}
                        freight_forwarder_id={props.match.params.freight_forwarder_id}
                        quote_id={props.match.params.quote_id}
                      />
                    );
                  }}
                />

                {/* *************************BULK UPDATES ****************************** */}
                <Route
                  exact
                  path={ROUTES.BULK_UPDATES}
                  render={(props) => (
                    <BulkUpdatesPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />

                {/* *************************RATE SHEETS ****************************** */}
                <Route
                  exact
                  path={ROUTES.RATE_SHEETS}
                  render={(props) => (
                    <RateSheetsPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />
                  )}
                />
                <Route
                  exact
                  path={ROUTES.RATE_SHEET}
                  render={(props) => {
                    let { currentFreightForwarder } = this.props;
                    return (
                      <RateSheetShowPage
                        {...props}
                        currentFreightForwarder={currentFreightForwarder}
                        freight_forwarder_id={props.match.params.freight_forwarder_id}
                        ratesheet_id={props.match.params.ratesheet_id}
                      />
                    );
                  }}
                />
              </Switch>
            </Suspense>
          </Grid>
        </Grid>
        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12}>
            <Footer />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default compose(withFreightForwarder, withStyles(styles, { withTheme: true }))(FreightForwarderRouter);
// export default compose(withAuthentication, withFreightForwarder, withStyles(styles, { withTheme: true }))(FreightForwarderRouter);
